﻿import { ConfigManager } from '@utils/ConfigManager';

export const getCanUseV3RouteInjection = () => {
  const envarForV3RouteInjection = ConfigManager.viteUseV3RouteInjection as
    | string
    | undefined;
  const useV3RouteInjection =
    envarForV3RouteInjection !== undefined &&
    envarForV3RouteInjection.toLowerCase() === 'true';
  return useV3RouteInjection;
};
